import { render, staticRenderFns } from "./k-field-rich.vue?vue&type=template&id=219cee1e&lang=html"
import script from "./k-field-rich.vue?vue&type=script&lang=js"
export * from "./k-field-rich.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports